module.exports = __webpack_public_path__ + "img/Image2.7d5b1c65.svg";